import styled from 'styled-components'
import theme from '../../theme'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.background.color};
  height:100%;
  margin:1rem;
  padding: 2rem;
  width: 100%;
  @media (max-width: 768px) {
   padding:1rem;
  }
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 100%;
  width: 70%;
  @media (max-width: 768px) {
    width:100%;
  }
`

export const FormContainer = styled.div`
  width: 90%;
  max-width: 400px;
  margin: 0 auto;
  /* @media (max-width: 768px) {
    width:100%;
  } */
`
export const Title = styled.h1`
  font-family: 'Inter';
  align-self: center;
  padding: 2rem 0;
  @media (max-width: 768px) {
   font-size:1.5rem;
  }
`

export const Paragraph = styled.p`
  font-size: 20px;
  padding: 0.5rem;
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const Input = styled.input`
  width: 90%;

  background: transparent;
  color: black;
  padding-left: 8px;
  outline: 0;
  border: none;
  font-size: 14px;
`

export const Button = styled.button`
  font-family: 'Inter'; 
  max-width: 100%;
  padding: 1rem;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  background-color: #2d60ff;
 border:2px solid #2d60ff;
 border-radius:10px;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  :hover {
    opacity: 0.8;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`
export const Label = styled.label`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #333b69;
  text-transform: uppercase;
`
export const InputWrapper = styled.div`
  display: flex;
  max-width: 100%;
  padding: 11px 8px;
  background: #e8f0f7;
  color: #f03d4e;
  margin-bottom: 2rem;
  margin-top: 0.5rem;
  border-radius: 10px;
  outline: 0;
  border: none;
  font-size: 14px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
  :focus,
  :hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
  }
`
export const HeadingStyled = styled.h3`
  font-family: Inter;
  font-style: normal;
  color:#2d60ff;
  text-align:right;
  padding-bottom:2rem;
`
export const ButtonNew = styled(Button)`
width:100%;
background-color:#fff;
padding:1rem;
margin:1rem 0;
color:#2d60ff;
`
export const LogoContainer = styled.div`
width:100%;
`
export const SelectStyled = styled.select`
  display: flex;
  max-width: 100%;
  padding: 11px 8px;
  background: #e8f0f7;
  color: #000;
  margin-bottom: 2rem;
  margin-top: 0.5rem;
  border-radius: 10px;
  outline: 0;
  border: none;
  font-size: 16px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
  :focus,
  :hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
  }
`


